import { render, staticRenderFns } from "./PbFloat.vue?vue&type=template&id=6df92d2a&"
import script from "./PbFloat.vue?vue&type=script&lang=js&"
export * from "./PbFloat.vue?vue&type=script&lang=js&"
import style0 from "./PbFloat.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports